import { api } from "..";
import { CashoutAccepted } from "@/types/ApiResponses/Cashout";

export interface AcceptCashoutParams {
  couponId: string;
  // The offer exactly as getCashoutOffers returned it.
  amount: number;
  expiresAt: number;
  token: string;
}

// POST /coupon-new/:id/cashout. The server may hold the request for the
// in-play delay before it re-prices; a refusal is a 409 CashoutConflict.
export const acceptCashout = async ({
  couponId,
  amount,
  expiresAt,
  token,
}: AcceptCashoutParams): Promise<CashoutAccepted> => {
  const res = await api.client.post(`/coupon-new/${couponId}/cashout`, {
    amount,
    expiresAt,
    token,
  });
  return res.data;
};
